//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AuditClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetAuditRecordsAuditQueryParameters = {
  tableName?: string | null | undefined ;
  patientId?: number | null | undefined ;
  startDate?: Date | null | undefined ;
  endDate?: Date | null | undefined ;
  userId?: string | null | undefined ;
  subtenantIds?: number[] | null | undefined ;
  changedProperties?: string[] | undefined ;
  filterCondition?: { [key: string]: string; } | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type GetTablePropertiesAuditQueryParameters = {
  tableName: string ;
}

export function getAuditRecordsUrl(tableName?: string | null | undefined, patientId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, userId?: string | null | undefined, subtenantIds?: number[] | null | undefined, changedProperties?: string[] | undefined, filterCondition?: { [key: string]: string; } | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/audit-records?";
if (tableName !== undefined && tableName !== null)
    url_ += "TableName=" + encodeURIComponent("" + tableName) + "&";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (startDate !== undefined && startDate !== null)
    url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
if (endDate !== undefined && endDate !== null)
    url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
if (userId !== undefined && userId !== null)
    url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
if (subtenantIds !== undefined && subtenantIds !== null)
    subtenantIds && subtenantIds.forEach(item => { url_ += "SubtenantIds=" + encodeURIComponent("" + item) + "&"; });
if (changedProperties === null)
    throw new Error("The parameter 'changedProperties' cannot be null.");
else if (changedProperties !== undefined)
    changedProperties && changedProperties.forEach(item => { url_ += "ChangedProperties=" + encodeURIComponent("" + item) + "&"; });
if (filterCondition === null)
    throw new Error("The parameter 'filterCondition' cannot be null.");
else if (filterCondition !== undefined)
    filterCondition && Object.keys(filterCondition).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + filterCondition[key]) + "&"; });
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAuditRecordsDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfAuditRecordDto, unknown, Types.PageableListDtoOfAuditRecordDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfAuditRecordDto, unknown, Types.PageableListDtoOfAuditRecordDto>, 'queryFn'>> = {
};
export function getGetAuditRecordsDefaultOptions() {
  return getAuditRecordsDefaultOptions;
};
export function setGetAuditRecordsDefaultOptions(options: typeof getAuditRecordsDefaultOptions) {
  getAuditRecordsDefaultOptions = options;
}

export function getAuditRecordsQueryKey(dto: GetAuditRecordsAuditQueryParameters): QueryKey;
export function getAuditRecordsQueryKey(tableName?: string | null | undefined, patientId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, userId?: string | null | undefined, subtenantIds?: number[] | null | undefined, changedProperties?: string[] | undefined, filterCondition?: { [key: string]: string; } | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getAuditRecordsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { tableName, patientId, startDate, endDate, userId, subtenantIds, changedProperties, filterCondition, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetAuditRecordsAuditQueryParameters;

    return trimArrayEnd([
        'AuditClient',
        'getAuditRecords',
        tableName as any,
        patientId as any,
        startDate as any,
        endDate as any,
        userId as any,
        subtenantIds as any,
        changedProperties as any,
        filterCondition as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'AuditClient',
        'getAuditRecords',
        ...params
      ]);
  }
}
export function __getAuditRecords(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAuditRecords(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as Date | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as number[] | null | undefined,       context.queryKey[8] as string[] | undefined,       context.queryKey[9] as { [key: string]: string; } | undefined,       context.queryKey[10] as number | undefined,       context.queryKey[11] as number | undefined,       context.queryKey[12] as string | null | undefined,       context.queryKey[13] as Types.SortDirection | undefined,       context.queryKey[14] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetAuditRecordsQuery<TSelectData = Types.PageableListDtoOfAuditRecordDto, TError = unknown>(dto: GetAuditRecordsAuditQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfAuditRecordDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all audit records.
 * @param tableName (optional) 
 * @param patientId (optional) 
 * @param startDate (optional) 
 * @param endDate (optional) 
 * @param userId (optional) 
 * @param subtenantIds (optional) 
 * @param changedProperties (optional) if TableName != null
 * @param filterCondition (optional) if TableName != null
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetAuditRecordsQuery<TSelectData = Types.PageableListDtoOfAuditRecordDto, TError = unknown>(tableName?: string | null | undefined, patientId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, userId?: string | null | undefined, subtenantIds?: number[] | null | undefined, changedProperties?: string[] | undefined, filterCondition?: { [key: string]: string; } | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfAuditRecordDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAuditRecordsQuery<TSelectData = Types.PageableListDtoOfAuditRecordDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfAuditRecordDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let tableName: any = undefined;
  let patientId: any = undefined;
  let startDate: any = undefined;
  let endDate: any = undefined;
  let userId: any = undefined;
  let subtenantIds: any = undefined;
  let changedProperties: any = undefined;
  let filterCondition: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ tableName, patientId, startDate, endDate, userId, subtenantIds, changedProperties, filterCondition, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetAuditRecordsAuditQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [tableName, patientId, startDate, endDate, userId, subtenantIds, changedProperties, filterCondition, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfAuditRecordDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAuditRecords(context, axiosConfig) : __getAuditRecords,
    queryKey: getAuditRecordsQueryKey(tableName, patientId, startDate, endDate, userId, subtenantIds, changedProperties, filterCondition, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getAuditRecordsDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfAuditRecordDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all audit records.
 * @param tableName (optional) 
 * @param patientId (optional) 
 * @param startDate (optional) 
 * @param endDate (optional) 
 * @param userId (optional) 
 * @param subtenantIds (optional) 
 * @param changedProperties (optional) if TableName != null
 * @param filterCondition (optional) if TableName != null
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetAuditRecordsData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfAuditRecordDto | undefined) => Types.PageableListDtoOfAuditRecordDto, tableName?: string | null | undefined, patientId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, userId?: string | null | undefined, subtenantIds?: number[] | null | undefined, changedProperties?: string[] | undefined, filterCondition?: { [key: string]: string; } | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getAuditRecordsQueryKey(tableName, patientId, startDate, endDate, userId, subtenantIds, changedProperties, filterCondition, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets all audit records.
 * @param tableName (optional) 
 * @param patientId (optional) 
 * @param startDate (optional) 
 * @param endDate (optional) 
 * @param userId (optional) 
 * @param subtenantIds (optional) 
 * @param changedProperties (optional) if TableName != null
 * @param filterCondition (optional) if TableName != null
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetAuditRecordsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfAuditRecordDto | undefined) => Types.PageableListDtoOfAuditRecordDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getTablePropertiesUrl(tableName: string): string {
  let url_ = getBaseUrl() + "/api/audit-records/{tableName}/properties";
if (tableName === undefined || tableName === null)
  throw new Error("The parameter 'tableName' must be defined.");
url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getTablePropertiesDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getGetTablePropertiesDefaultOptions() {
  return getTablePropertiesDefaultOptions;
};
export function setGetTablePropertiesDefaultOptions(options: typeof getTablePropertiesDefaultOptions) {
  getTablePropertiesDefaultOptions = options;
}

export function getTablePropertiesQueryKey(tableName: string): QueryKey;
export function getTablePropertiesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { tableName,  } = params[0] as GetTablePropertiesAuditQueryParameters;

    return trimArrayEnd([
        'AuditClient',
        'getTableProperties',
        tableName as any,
      ]);
  } else {
    return trimArrayEnd([
        'AuditClient',
        'getTableProperties',
        ...params
      ]);
  }
}
export function __getTableProperties(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getTableProperties(
      context.queryKey[2] as string,axiosConfig    );
}

export function useGetTablePropertiesQuery<TSelectData = string[], TError = unknown>(dto: GetTablePropertiesAuditQueryParameters, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all properties for a table.
 * @param tableName The table name.
 */
export function useGetTablePropertiesQuery<TSelectData = string[], TError = unknown>(tableName: string, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetTablePropertiesQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let tableName: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ tableName,  } = params[0] as GetTablePropertiesAuditQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [tableName, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getTableProperties(context, axiosConfig) : __getTableProperties,
    queryKey: getTablePropertiesQueryKey(tableName),
    ...getTablePropertiesDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all properties for a table.
 * @param tableName The table name.
 */
export function setGetTablePropertiesData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], tableName: string) {
  queryClient.setQueryData(getTablePropertiesQueryKey(tableName),
    updater
  );
}

/**
 * Gets all properties for a table.
 * @param tableName The table name.
 */
export function setGetTablePropertiesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getTableNamesUrl(): string {
  let url_ = getBaseUrl() + "/api/audit-records/table-names";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getTableNamesDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getGetTableNamesDefaultOptions() {
  return getTableNamesDefaultOptions;
};
export function setGetTableNamesDefaultOptions(options: typeof getTableNamesDefaultOptions) {
  getTableNamesDefaultOptions = options;
}

export function getTableNamesQueryKey(): QueryKey;
export function getTableNamesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'AuditClient',
      'getTableNames',
    ]);
}
export function __getTableNames(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getTableNames(
axiosConfig    );
}

/**
 * Gets table names.
 */
export function useGetTableNamesQuery<TSelectData = string[], TError = unknown>(options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetTableNamesQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getTableNames(context, axiosConfig) : __getTableNames,
    queryKey: getTableNamesQueryKey(),
    ...getTableNamesDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets table names.
 */
export function setGetTableNamesData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], ) {
  queryClient.setQueryData(getTableNamesQueryKey(),
    updater
  );
}

/**
 * Gets table names.
 */
export function setGetTableNamesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getSortFieldsUrl(): string {
  let url_ = getBaseUrl() + "/api/audit-records/sort-fields";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSortFieldsDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getGetSortFieldsDefaultOptions() {
  return getSortFieldsDefaultOptions;
};
export function setGetSortFieldsDefaultOptions(options: typeof getSortFieldsDefaultOptions) {
  getSortFieldsDefaultOptions = options;
}

export function getSortFieldsQueryKey(): QueryKey;
export function getSortFieldsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'AuditClient',
      'getSortFields',
    ]);
}
export function __getSortFields(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSortFields(
axiosConfig    );
}

/**
 * Gets properties for sorting.
 */
export function useGetSortFieldsQuery<TSelectData = string[], TError = unknown>(options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSortFieldsQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSortFields(context, axiosConfig) : __getSortFields,
    queryKey: getSortFieldsQueryKey(),
    ...getSortFieldsDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets properties for sorting.
 */
export function setGetSortFieldsData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], ) {
  queryClient.setQueryData(getSortFieldsQueryKey(),
    updater
  );
}

/**
 * Gets properties for sorting.
 */
export function setGetSortFieldsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}